<script lang="ts">
    import RewardsLink from "@apps/rewards/components/RewardsLink.svelte";
    import type { FreeProductRewardEntity } from "@apps/rewards/entities/entities";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import type { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";

    import ProductContainer from "@components/ProductContainer.svelte";
    import T from "@components/T.svelte";

    //Props
    export let reward: FreeProductRewardEntity;
    export let urlsBuilder: URLsBuilder;
    export let namespace: TranslationNamespaces;

    const discount = Math.abs(reward.discountValue);
    const maxDiscount = 100;
</script>

<ProductContainer
    let:productInfo={{ product, variant }}
    productId={reward.productId}
    variantId={reward.variants[0].id}
>
    {#if product && variant}
        <RewardsLink
            href={urlsBuilder.createProductUrl(product.handle, variant.id)}
        >
            {#if discount === maxDiscount}
                <T
                    {namespace}
                    translationKey="free_product_reward_max_discount"
                />
            {:else}
                <T
                    {namespace}
                    translationKey="free_product_reward_variable_discount"
                    translationOptions={{
                        discount,
                    }}
                />
            {/if}
        </RewardsLink>
    {/if}
</ProductContainer>
